import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, IconButton, TextField, Typography, Button, CircularProgress, Alert } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { fetchRawStockCodes, deleteRawStockCode } from '../../redux/actions/rawStockCode/rawStockCodeAction';

const RawStockCodeTable = ({ onEdit, refreshTrigger }) => {
  const dispatch = useDispatch();
  const { rawStockCodes, loading, error } = useSelector(state => state.rawStockCode);
  const { user } = useSelector((state) => state.login);
  const [filterText, setFilterText] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    dispatch(fetchRawStockCodes());
  }, [dispatch, refreshTrigger]);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this stock code?')) {
      dispatch(deleteRawStockCode(id)).then(() => {
        setSuccessMessage('Stock code deleted successfully!');
        setTimeout(() => setSuccessMessage(''), 3000);
        if (typeof refreshTrigger === 'function') refreshTrigger();
      });
    }
  };

  const handleNew = () => {
    onEdit(null);
  };

  const filteredCodes = rawStockCodes.filter((code) =>
    (code.stock_code || '').toLowerCase().includes(filterText.toLowerCase())
  );

  if (loading) {
    return <CircularProgress />;
  }

  const cellStyle = { padding: 8, borderBottom: '1px solid #eee', textAlign: 'center' };
  const headerStyle = { fontWeight: 'bold', padding: 8, borderBottom: '1px solid #ccc', textAlign: 'center' };

  return (
    <Box>
      {/* Header Row with Title & Search */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Stock Codes
          </Typography>
          {user?.role === 'Admin' && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleNew}
              size="small"
              sx={{
                backgroundColor: '#2196f3',
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
              }}
            >
              New
            </Button>
          )}
        </Box>
        <TextField
          size="small"
          placeholder="Search stock code..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          sx={{
            width: '250px',
            '& .MuiInputBase-root': {
              backgroundColor: 'transparent',
            },
          }}
        />
      </Box>
      {successMessage && <Alert severity="success">{successMessage}</Alert>}
      {error && <Alert severity="error">{error}</Alert>}
      <Box sx={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={headerStyle}>Stock Code</th>
              <th style={headerStyle}>Stock Name</th>
              <th style={headerStyle}>Stock Type</th>
              <th style={headerStyle}>Karatage</th>
              <th style={headerStyle}>Color</th>
              <th style={headerStyle}>Stone Type</th>
              {user?.role === 'Admin' && <th style={headerStyle}>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {filteredCodes.map((row) => (
              <tr key={row.id}>
                <td style={cellStyle}>{row.stock_code}</td>
                <td style={cellStyle}>{row.stock_name}</td>
                <td style={cellStyle}>{row.stock_type}</td>
                <td style={cellStyle}>{row.karatage}</td>
                <td style={cellStyle}>{row.color}</td>
                <td style={cellStyle}>{row.stone_type}</td>
                {user?.role === 'Admin' && (
                  <td style={cellStyle}>
                    <IconButton size="small" onClick={() => onEdit(row)}>
                      <EditIcon fontSize="small" sx={{ color: '#2196f3' }} />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleDelete(row.id)}>
                      <DeleteIcon fontSize="small" sx={{ color: '#f44336' }} />
                    </IconButton>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};

export default RawStockCodeTable; 